export default "__VITE_ASSET__797d8b4b__"